import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import api from '@/api';
import { nextArchivePage, PAGE_SIZE } from '@/archive/PostArchive';
import { TermArchive } from '@/archive/TermArchive';
import { apiLanguage } from '~/i18n';
import { localeToApiLanguage } from '~/utils/languageFormat';

/**
 * `/study-helper-news/category/$slug`, the study helper news category archive.
 */
function StudyHelperNewsTermArchive(): ReactElement | null {
  const { slug } = Route.useParams();
  // The interface language, which is part of the query key. Unlike legacy
  // there's no language prefix in the URL.
  const language = localeToApiLanguage(apiLanguage());

  const query = api.listStudyHelperNews.useInfiniteQuery(
    { query: { language, category: slug, limit: PAGE_SIZE } },
    {
      initialPageParam: { query: { offset: 0 } },
      // Wrapped rather than passed by reference: an annotated `lastPage`
      // would be inferred as the operation's `TQueryFnData` and collapse the
      // page type to the helper's structural one.
      getNextPageParam: (lastPage, allPages) =>
        nextArchivePage(lastPage, allPages),
    },
  );

  return (
    <TermArchive
      query={query}
      taxonomy="study_helper_news_category"
      slug={slug}
      headingKey="wbs.study-helper-news"
      basePath="/study-helper-news"
      emptyTestId="study-helper-news-empty"
      sidebarKey="study-helper-news-sidebar"
      categoryTo="/study-helper-news/category/$slug"
      language={language}
    />
  );
}

export const Route = createFileRoute('/_app/study-helper-news/category/$slug')({
  component: StudyHelperNewsTermArchive,
});
